import { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import './Styles.css';
import { Card } from "./Card";
import { initNavigation } from "../../../providers/actions";
import { BoasVindas } from "../WelcomeMessage";
const mapDispatchToProps = { initNavigation }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

export const PainelCards =	
	// redux
	connect(
		(mapStateToProps),
		(mapDispatchToProps)
	)(
		withRouter(
			class extends Component {

				componentDidMount(){
					this.props.initNavigation();
				}

				render() {
					const { user } = this.props;
					let itensMenu = [];
					let submenusComCards = [];

					if (user && user.menu.length > 0) {
						itensMenu = user.menu;
						submenusComCards = itensMenu.map(menu => menu.submenus); 
						submenusComCards = [].concat(...submenusComCards).filter(submenu =>  Boolean(submenu.card) && submenu.grupo !== "GRANDES_VOLUMES");
					}

					return (
						<Fragment>
							{(user && user.menu) &&
								<Fragment>
									<BoasVindas/>

									<div className='home-cards'>
										{submenusComCards && submenusComCards.map(submenu => 
											<Card key={submenu.id} titulo={submenu.card.titulo} icone={submenu.card.icone} onClick={() => submenu.linkExterno ? window.open(submenu.link,'_blank') : this.props.history.push({pathname: submenu.link, state: { resetSearch: true }})}/>
										)}
									</div>
								</Fragment>
							}
						</Fragment>
					);
				}


				
			}
		)

	)